import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

import { WorkoutModel } from '../../../models/models';

@Component({
  selector: 'page-dashboard-workout-exercises',
  templateUrl: 'dashboard-workout-exercises.html',
})
export class DashboardWorkoutExercisesPage {
  workout: WorkoutModel;

  constructor(
    private params: NavParams,
    private viewCtrl: ViewController) {
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  ionViewWillLoad() {
    this.workout = this.params.get('workout');
  }

}


// WEBPACK FOOTER //
// ./src/pages/dashboard/exercise/dashboard-workout-exercises.ts